import styled from 'styled-components'
import { colors, sizes } from 'client/styles'

export const RoomCardBase = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  padding-block: 16px;
  padding-inline: 16px;

  background: ${colors.white};
  border: 1px solid ${colors.grey4};
  border-radius: 8px;
  overflow: hidden;

  @media screen and (max-width: ${sizes.desktop - 1}px) {
    max-width: 100%;
    width: 100%;
  }
`

export const Row = styled.div`
  display: flex;
  width: 100%;

  padding-block-end: 8px;
`

export const RoomDescription = styled(Row)`
  padding-block-start: 0;
`

export const HolderInformation = styled(Row)`
  padding-block-end: 12px;
`

export const Label = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  padding-inline-end: 12px;

  color: ${colors.grey1};
`

export const LabelBold = styled(Label)`
  font-weight: 700;
`

export const Value = styled.div`
  font-size: 16px;
  line-height: 150%;
  padding-inline-end: 5px;

  color: ${colors.grey2};
`

export const Holder = styled(Value)`
  font-size: 14px;
`

export const BoardWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  margin-block-end: 8px;

  color: ${colors.grey2};
`
